import { isMobile, slideToggle, slideUp, slideDown, dataMediaQueries, windowScrollY, scrollHeight, disableScroll, enableScroll, ifTargetElement, toggleClasses, getCookies, setCookies } from '../tech/tech.js';
const circle = document.querySelector('._to-top__circle--progress');
const line = document.querySelector('.progressline__line');
const windowHeight = window.innerHeight;

const die = {
    burgerMenu: (burgerElement, menu, menuArrow, overlay) => {
        const burger = document?.querySelector(burgerElement);
        const nav = document?.querySelector(menu);
        const navItems = nav?.querySelectorAll('a, .btn');
        const arrows = nav?.querySelectorAll(menuArrow);
        let open = false;


        const clickOverlay = () => {
            const createMenuOverlay = '<div class="menu__overlay"></div>';
            document.querySelector('.menu__body').insertAdjacentHTML('afterend', createMenuOverlay);

            const menuOverlay = document.querySelector('.menu__overlay');
            menuOverlay.addEventListener('click', (e) => {
                burger.click();
            });

            // !!! 
            const burgerClose = document.querySelector('.burger--close');
            if (burgerClose) {
                burgerClose.addEventListener('click', () => {
                    document.querySelector('.burger').click();
                });
            } else {
                document.querySelector('.menu__body').insertAdjacentHTML('afterbegin', '<button class="burger--close" aria-label="Navigation Close"></button>');
                const burgerClose = document.querySelector('.burger--close');
                burgerClose.addEventListener('click', () => {
                    document.querySelector('.burger').click();
                });
            }
            // 
        }

        burger?.addEventListener('click', () => {

            if (open) {
                enableScroll();
                if (overlay === 'overlay') {
                    document.querySelector('.menu__overlay').remove();
                }
                // !!! 
                const burgerClose = document.querySelector('.burger--close');
                if (burgerClose) { burgerClose.remove(); }
                //

                open = false;
            } else {
                disableScroll();
                if (overlay === 'overlay') {
                    clickOverlay();
                }
                open = true;

            }


            burger?.classList.toggle('burger--active');
            nav?.classList.toggle('menu--open');
            document.querySelector('.header').classList.toggle('menuopen');
            document.querySelector('body').classList.toggle('bodymenuopen');

        });

        const arrowRemoveActive = () => {
            for (let i = 0; i < arrows.length; i++) {
                arrows[i].parentElement.classList.remove('-subactive');
            }
        }
        const arrowAddActive = (el) => {
            el.classList.add('-subactive');
        }

        arrows.forEach(ar => {
            ar.addEventListener('click', () => {
                if (ar.parentElement.classList.contains('-subactive')) {
                    ar.parentElement.classList.remove('-subactive');
                } else {
                    arrowRemoveActive();
                    arrowAddActive(ar.parentElement);
                }


            });
        });

        navItems.forEach(el => {
            el.addEventListener('click', () => {
                enableScroll();
                burger?.classList.remove('burger--active');
                nav?.classList.remove('menu--open');
                document.querySelector('.header').classList.remove('menuopen');
                document.querySelector('body').classList.remove('bodymenuopen');
            });
        });
    },
    fixed: (element, padding) => {
        const fixedBlock = document.querySelector(element);
        const body = document.body;
        const sticky = fixedBlock.offsetTop;
        if (window.pageYOffset > sticky) {
            fixedBlock.classList.add("fixed");
            body.classList.add("fixed");
            if (padding) {
                document.querySelector('.wrapper').style = 'padding-top:' + fixedBlock.offsetHeight + 'px';
            }
        } else {
            fixedBlock.classList.remove("fixed");
            body.classList.remove("fixed");
            document.querySelector('.wrapper').style = '';
        }
    },
    fixedLogic: (element, header) => {

        const body = document.body;
        const fixedNav = document.querySelector(element);
        const fixedHeader = document.querySelector(header);
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= 0) {
                body.classList.remove('up');
                return;
            }

            if (currentScroll > lastScroll && !body.classList.contains('down')) {
                // down
                body.classList.remove('up');
                body.classList.add('down');
            } else if (
                currentScroll < lastScroll &&
                body.classList.contains('down')
            ) {
                // up
                body.classList.remove('down');
                body.classList.add('up');
                fixedNav.classList.add('fixed');
                fixedHeader.classList.add('fixed');
            }
            lastScroll = currentScroll;
        })
    },
    spoilers: () => {
        const spoilers = document.querySelectorAll('[data-spoiler]');
        if (spoilers.length > 0) {

            const spoilerBody = (spoiler) => {
                spoiler.firstElementChild.nextElementSibling.hidden = true;
            }
            const spoilerBodyNo = (spoiler) => {
                spoiler.firstElementChild.nextElementSibling.hidden = false;
            }

            const spoilerClick = (e) => {
                e.preventDefault();
                const target = e.target;
                const spoilerFather = target.closest('.spoiler');
                if (spoilerFather) {
                    const spoilerTitle = spoilerFather.firstElementChild;
                    const spoilerBody = spoilerFather.lastElementChild;
                    spoilerTitle.classList.toggle('spoiler__open');
                    spoilerBody.classList.toggle('spoiler__open');
                    slideToggle(spoilerTitle.nextElementSibling, 500);
                }
            }

            const spoilersInit = (spoilersObj, media = false) => {
                spoilersObj.forEach(spoilerItem => {
                    spoilerItem = media ? spoilerItem.item : spoilerItem;
                    if (!spoilerItem.classList.contains('spoiler')) {
                        spoilerItem.classList.add('spoiler');
                    }
                    if (media.matches || !media) {
                        spoilerItem.classList.add('spoiler__init');
                        spoilerBody(spoilerItem);
                        spoilerItem.addEventListener('click', spoilerClick);
                    } else {
                        spoilerItem.classList.remove('spoiler__init');
                        spoilerBodyNo(spoilerItem);
                        spoilerItem.removeEventListener('click', spoilerClick);
                    }
                })

            }

            const spoilerBreackpoint = Array.from(spoilers).filter((breackpoint) => {
                return !breackpoint.dataset.spoiler.split(",")[0];
            });
            if (spoilerBreackpoint.length) {
                spoilersInit(spoilerBreackpoint);
            }

            let mdQueriesArray = dataMediaQueries(spoilers, "spoiler");
            if (mdQueriesArray && mdQueriesArray.length) {
                mdQueriesArray.forEach(mdQueriesItem => {
                    // Событие
                    mdQueriesItem.matchMedia.addEventListener("change", function () {
                        spoilersInit(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
                    });
                    spoilersInit(mdQueriesItem.itemsArray, mdQueriesItem.matchMedia);
                });
            }
            //spoilersInit(spoilers);
        }
    },
    // <span data-count="0,300,5000,">0</span>
    // <span data-count="10,30,5000,">0</span>
    // <span data-count="100,50,5000,">0</span>
    // <span data-count="-100,-500,5000,">0</span>
    // <span data-count="0,300,5000,%">0</span>
    // <span data-count="0,300,5000,+">0</span>
    countAnimation: () => {
        const counters = document.querySelectorAll('[data-count]');

        const numberAnimation = (counter, numberStart, numberEnd, duration, symbol) => {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                const increment = Math.floor(progress * (numberEnd - numberStart) + numberStart);
                counter.innerText = increment + symbol;
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        if (counters.length > 0) {
            counters.forEach((counter) => {
                const counterSplit = counter.dataset.count.split(",");
                const numberStart = +(counterSplit[0]);
                const numberEnd = +(counterSplit[1]);
                const duration = +(counterSplit[2]);
                const symbol = counterSplit[3];

                numberAnimation(counter, numberStart, numberEnd, duration, symbol);
            });
        }
    },
    // style scss @import "base/modules/img-to-bg";
    imgToBackground: () => {
        const cbg = document.querySelectorAll('._cbg');
        if (cbg.length > 0) {
            for (let i = 0; cbg.length > i; i++) {
                let src = cbg[i].querySelector('img').getAttribute('src');
                const objectFit = cbg[i].dataset.objectfit;
                cbg[i].style.backgroundImage = 'url("' + src + '")';
                cbg[i].style.backgroundSize = objectFit;
                cbg[i].querySelector('img').remove();
            }
        }
    },
    // style scss @import "base/modules/fullscreen";
    fullscreen: () => {
        const fullScreens = document.querySelector('[data-fullscreen]');
        //if (fullScreens && isMobile.any()) {
        if (fullScreens) {
            const resizeHeight = () => {
                let windowHeight = window.innerHeight * 0.01;
                const datasetElement = fullScreens.dataset.fullscreen;
                let vh;
                if (datasetElement) {
                    const innerElement = document.querySelector(datasetElement);
                    vh = windowHeight - innerElement.offsetHeight * 0.01;
                } else {
                    vh = windowHeight;
                }
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }
            window.addEventListener('resize', resizeHeight);
            resizeHeight();
        }
    },

    // All scrollTo function
    scrollToBlock: (targetBlockElement) => {
        let targetBlockElementPosition = document.querySelector(targetBlockElement).getBoundingClientRect().top + scrollY;
        let headerItem = document.querySelector('header.header');
        let headerItemHeight = 0;
        if (headerItem) {
            headerItemHeight = headerItem.offsetHeight;
        }
        window.scrollTo({
            top: headerItemHeight ? targetBlockElementPosition - headerItemHeight : targetBlockElementPosition,
            behavior: "smooth"
        });
    },
    /**
     * <li class="scroll-to"><a href="#to-block">item</a></li>
     * <div class="to-block">content</div>
     * die.elementsScrollTo('class'); 'class', 'id'
     */
    elementsScrollTo: (type) => {
        const link = document.querySelectorAll('.scroll-to a, [data-to]');

        const linkHref = (e) => {
            e.preventDefault();
            const targetElement = e.target;
            let typeTo = '';
            if (type === 'id') {
                typeTo = '#'
            } else {
                typeTo = '.'
            }
            if (targetElement.closest('.scroll-to')) {
                const href = targetElement?.getAttribute('href').replace('#', typeTo);
                scrollToBlock(href);
            } else {
                const dataTo = targetElement?.dataset.to.replace('#', typeTo);
                scrollToBlock(dataTo);
            }
        }
        link.forEach(link => {
            link.addEventListener('click', linkHref);
        });
    },
    currentYear: (selector) => {
        if (selector) {
            const selectBlock = document.querySelector(selector);
            selectBlock.innerText = new Date().getFullYear();
        }
    },
    // button scroll top
    // style scss @import "base/modules/to-top";
    // <div class="_to-top"></div>
    //die.toTop();
    /**
     * <div class="_to-top">
         <svg class="_to-top__circle" viewBox="-10 -10 300 300">
           <circle class="_to-top__circle--progress" r="140" cx="140" cy="140" fill="none" stroke="crimson" stroke-width="20"></circle>
         </svg>
       </div>
     */
    toTop: (param) => {
        const scrollToTopButton = document.getElementsByClassName("_to-top")[0];
        let scrollTop = windowScrollY();
        let pageHeight = scrollHeight();
        if (scrollToTopButton) {
            if (scrollTop > 0) {
                scrollToTopButton.className = "_to-top show";
            } else {
                scrollToTopButton.className = "_to-top hide";
            }

            //window.addEventListener("scroll", toTop);
            const scrollToTop = () => {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
            scrollToTopButton.addEventListener("click", scrollToTop);
        }
        if (param === 'animation' && circle) {
            let percentProgress = Math.floor(scrollTop / (pageHeight - windowHeight) * 100);

            let radius = circle.getAttribute('r');
            let circleLength = 2 * Math.PI * radius;
            circle.setAttribute('stroke-dasharray', circleLength);
            circle.setAttribute('stroke-dashoffset', circleLength - circleLength * percentProgress / 100);
        }
    },
    // style scss @import "base/modules/progressline";
    /**
     * <div class="progressline">
         <div class="progressline__line"></div>
       </div>
     */
    progressLine: () => {
        if (line) {
            let scrollTop = windowScrollY();
            let pageHeight = scrollHeight();
            let percentageProgress = Math.floor(scrollTop / (pageHeight - windowHeight) * 100);
            line.style.width = `${percentageProgress}%`;
        }
    },

    showhide: (elem) => {
        const showbtn = document.querySelectorAll(elem);

        const showblock = (e) => {
            e.preventDefault;
            let target = ifTargetElement(e.target, elem);
            // (/\.|#/g) = /\ .  - замінити крапку | - і, або # дієз  #/g
            /*if (e.target.classList.contains(elem.replace(/\.|#/g, ''))) {
                target = e.target;
            } else {
                target = e.target.closest(elem);
            }*/
            const prevElem = target.previousElementSibling;

            prevElem.classList.toggle('show');
            target.classList.toggle('show');
            slideToggle(prevElem, 500);

        }

        if (showbtn.length > 0) {
            for (let i = 0; i < showbtn.length; i++) {
                showbtn[i].previousElementSibling.hidden = true;
                showbtn[i].addEventListener('click', showblock);
            }
        }
    },

    faq: (quest, icon) => {
        const question = document.querySelectorAll(quest);

        const slidesClose = () => {
            for (let i = 0; i < question.length; i++) {
                question[i].querySelector(icon).classList.remove('icon-close');
                question[i].querySelector(icon).classList.add('icon-down');
                slideUp(question[i].nextElementSibling, 100);
                question[i].classList.remove('show');
                question[i].nextElementSibling.classList.remove('show');
            }
        }
        const faqToggle = (e) => {
            e.preventDefault;
            if (e.target.closest('.icon-close')) {
                slidesClose();
            } else {
                slidesClose();
                let target = ifTargetElement(e.target, quest);

                const reply = target.nextElementSibling;
                reply.classList.toggle('show');
                target.classList.toggle('show');

                setTimeout(() => {
                    toggleClasses(target.querySelector(icon), 'icon-down icon-close');
                    slideDown(reply, 500);
                }, 100)
            }
        }

        if (question.length > 0) {
            for (let i = 0; i < question.length; i++) {
                question[i].nextElementSibling.hidden = true;
                question[i].addEventListener('click', faqToggle);

            }
        }
    },

    // Cookie Modals
    cookieModal: (element) => {
        const cookieBlock = document.querySelector(element);
        cookieBlock.querySelector('.cookie_accept__close').addEventListener('click', () => {
            cookieBlock.classList.remove('open');
        });

        const checkCookies = () => {
            const acceptButtons = cookieBlock.querySelectorAll('.cookie_accept__btn, .cookie_settings__accept');

            if (!getCookies('cookies_policy')) {
                cookieBlock.classList.add('open');
            }

            if (acceptButtons.length > 0) {
                for (let i = 0; i < acceptButtons.length; i++) {
                    acceptButtons[i].addEventListener('click', () => {
                        setCookies('cookies_policy', 'true', 365);
                        cookieBlock.classList.remove('open');
                    });
                }
            }
        }
        checkCookies();
    },
}

export const burgerMenu = die.burgerMenu;
export const fixed = die.fixed;
export const fixedLogic = die.fixedLogic;
export const spoilers = die.spoilers;
export const countAnimation = die.countAnimation;
export const imgToBackground = die.imgToBackground;
export const fullscreen = die.fullscreen;
export const elementsScrollTo = die.elementsScrollTo;
export const scrollToBlock = die.scrollToBlock;
export const currentYear = die.currentYear;
export const toTop = die.toTop;
export const progressLine = die.progressLine;
export const showhide = die.showhide;
export const faq = die.faq;
export const cookieModal = die.cookieModal;

